<template>
    <ul
        v-if="subCategories?.length"
        :class="$style.subCategories"
    >
        <li
            v-for="subCategory in subCategories"
            :key="subCategory.id"
        >
            <BaseLink
                color="carbon-400"
                :style="{
                    '--candy-color': 0xffffff,
                }"
                :class="$style.link"
                data-interface-target="category"
                :to="subCategory.href"
            >
                <Typography
                    type="label"
                    size="s"
                    :responsive="false"
                >
                    {{ subCategory.title }}
                </Typography>
            </BaseLink>
        </li>
    </ul>
</template>
<script setup lang="ts">
import BaseLink from '@/components_new/BaseLink.vue'
import Typography from '@/components_new/Typography.vue'
import { CategoryInfo } from '@/types'

defineProps<{
    subCategories?: CategoryInfo['subCategories']
    externalLinks?: boolean
}>()
</script>
<style module>
.link {
    display: flex;
    white-space: nowrap;
    box-sizing: border-box;
    height: 32px;
    padding: 0 12px;
    line-height: 100%;
    align-items: center;
    gap: 8px;
    transition: all 0.2s ease-in;
    border-radius: 1000px;
    border: 1px solid #1d1d21;
    background: var(--carbon-200);
    box-shadow: 0 0 12px 0 var(--deep-blue-500) inset;
}

.link:hover {
    color: var(--lavander-600);
    background: var(--purple-400);
    box-shadow: none;
    border: 1px solid var(--purple-400);
}

.subCategories {
    display: flex;
    overflow-x: auto;
    scrollbar-width: none;
    margin-top: 8px;
    gap: 4px;
    margin-left: calc((var(--global-padding-horizontal) + var(--pg-safe-area-right)) * -1);
    margin-right: calc(var(--global-padding-horizontal) * -1);
}

.subCategories::-webkit-scrollbar {
    display: none;
}

.subCategories li:first-child {
    margin-left: calc(var(--global-padding-horizontal) + var(--pg-safe-area-left));
}

.subCategories li:last-child {
    margin-right: calc(var(--global-padding-horizontal) + var(--pg-safe-area-right));
}
</style>
